import { useState, useEffect } from "react";
import withRouter from "components/utils/withRouter.js";
import styles from "styles/public.module.css";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Authenticator from "services/Authenticator.js";
import { sessionCookieOptions } from "utils/TokenStorage.js";
import Cookies from "universal-cookie";

const cookies = new Cookies();

function RoleSelection(props) {
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    // Check if user is authenticated and has roles
    if (!Authenticator.isAuthenticated()) {
      props.navigate("/account");
      return;
    }

    const userRoles = Authenticator.getUserRoles();
    if (!userRoles.length) {
      props.navigate("/account");
      return;
    }
  }, [props]);

  const handleRoleSelection = (roleType) => {
    setIsProcessing(true);

    // Get roles from cookie (stored during authentication)
    const roles = Authenticator.getUserRoles();

    if (!roles.length) {
      props.navigate("/account");
      return;
    }

    let navigateTo = "/hospital";
    let selectedRole = roles[0];

    if (roleType === "patient") {
      navigateTo = "/patient";
      selectedRole = "PATIENT";
    } else {
      // Staff role - find the first staff role from the list
      const staffRoles = ["SUPER_ADMIN", "ORGANIZATION_ADMIN", "ASSISTANT", "DOCTOR", "HOSPITAL_ADMIN"];
      selectedRole = roles.find(role => staffRoles.includes(role)) || roles[0];
    }

    // Set the selected role
    cookies.set("user_role_type", selectedRole, sessionCookieOptions());
    cookies.set("start_view_path", navigateTo, sessionCookieOptions());

    // Navigate to the selected view
    props.navigate(navigateTo);
  };

  return (
    <Paper elevation={0} className={styles["form-container"]}>
      <h4>Choose Your Access</h4>
      <p className="text-muted mb-4">
        You have access to multiple roles. Please choose how you would like to proceed.
      </p>

      <div className="d-flex flex-column gap-3">
        <Button
          variant="contained"
          size="large"
          onClick={() => handleRoleSelection("patient")}
          disabled={isProcessing}
          className="py-3"
        >
          Access as Patient
        </Button>

        <Button
          variant="contained"
          size="large"
          onClick={() => handleRoleSelection("staff")}
          disabled={isProcessing}
          className="py-3"
        >
          Access as Staff
        </Button>
      </div>
    </Paper>
  );
}

export default withRouter(RoleSelection);

